import React, { useEffect, useState } from 'react';
import { fetchFilters } from '../slot_booking/shared/apis';
import { alertApiError, urlParamsObject } from '../../../../helperFunctions';
import PreFilterForm from './PreFilterForm';
import { submitFilters } from './apis';
import { useUtilities } from '../../../../context/utilities';

const PreFilter = ({ locale }) => {
  const [filterFieldsData, setFilterFieldsData] = useState({});

  const urlParams = urlParamsObject();

  const { showSpinner, hideSpinner } = useUtilities();

  const loadFilters = () => {
    showSpinner();
    return fetchFilters(urlParams?.survey_id, true).finally(() => {
      hideSpinner();
    });
  };

  const handleSubmit = (values) => {
    const surveyId = urlParams?.survey_id;
    if (!surveyId && !values) {
      return;
    }
    showSpinner();
    submitFilters(surveyId, values)
      .then((r) => {
        const redirectURL = r?.data.redirect_url;
        if (redirectURL) {
          window.location.href = redirectURL;
        } else {
          hideSpinner();
          alert('Something went wrong!');
        }
      })
      .catch((e) => {
        hideSpinner();
        alertApiError(e);
      });
  };

  useEffect(() => {
    loadFilters().then((r) => {
      const { data } = r;
      if (data) {
        setFilterFieldsData(data);
      }
    });
  }, []);

  return (
    <PreFilterForm
      filterFieldsData={filterFieldsData}
      onSubmit={handleSubmit}
      locale={locale}
    />
  );
};

export default PreFilter;
